<h2 mat-dialog-title>Run Auto-Assign</h2>

<mat-dialog-content>
  <p class="dialog-copy">
    This will run auto-assign for all games matching the current schedule
    filters.
  </p>

  <div class="summary-panel">
    <div class="summary-label">Games affected</div>
    <div class="summary-count">{{ data.gameCount }}</div>
  </div>

  <div class="filter-section">
    <div class="filter-section-title">Active filters</div>

    <div class="filter-empty" *ngIf="data.filterItems.length === 0">
      No active filters. Auto-assign will run for all schedule games.
    </div>

    <div class="filter-grid" *ngIf="data.filterItems.length > 0">
      <ng-container *ngFor="let item of data.filterItems">
        <div class="filter-grid-label">{{ item.label }}</div>
        <div class="filter-grid-value">{{ item.value }}</div>
      </ng-container>
    </div>
  </div>

  <div class="warning-message" *ngIf="data.warningMessage">
    {{ data.warningMessage }}
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close(false)">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="!data.canConfirm"
    (click)="close(true)"
  >
    Run AA
  </button>
</mat-dialog-actions>
